import React from "react";
export const Check = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 11 8"
    className="check-svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.2071 0.292893C9.81658 -0.0976311 9.18342 -0.0976311 8.79289 0.292893L3.5 5.58579L1.70711 3.79289C1.31658 3.40237 0.683418 3.40237 0.292894 3.79289C-0.0976312 4.18342 -0.0976312 4.81658 0.292894 5.20711L2.79289 7.70711C3.18342 8.09763 3.81658 8.09763 4.20711 7.70711L10.2071 1.70711C10.5976 1.31658 10.5976 0.683417 10.2071 0.292893Z"
    />
  </svg>
);
